<template>
  <div v-if="workflowDefinition">
    <!-- Vue mount component but props is undefined -->
    <h1>{{ workflowDefinition.name }}</h1>
    <JsonEditor :value="workflowDefinition" @input="setWorkflowDefinition" />
    <button @click="updateWorkflowDefinition(workflowDefinition)">Save</button>
    <button
      @click="
        cancelUpdateWorkflowDefinition([
          workflowDefinitionName,
          workflowDefinitionVersion
        ])
      "
    >
      Cancel
    </button>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import JsonEditor from '@/components/JsonEditor.vue'

export default {
  name: 'WorkflowDefinitionEdit',
  props: ['workflowDefinitionName', 'workflowDefinitionVersion'],
  computed: mapState(['workflowDefinition']),
  methods: {
    ...mapActions([
      'getWorkflowDefinition',
      'updateWorkflowDefinition',
      'cancelUpdateWorkflowDefinition'
    ]),
    ...mapMutations(['setWorkflowDefinition'])
  },
  created() {
    this.getWorkflowDefinition([
      this.workflowDefinitionName,
      this.workflowDefinitionVersion
    ])
  },
  watch: {
    workflowDefinitionName: function() {
      this.getWorkflowDefinition([
        this.workflowDefinitionName,
        this.workflowDefinitionVersion
      ])
    },
    workflowDefinitionVersion: function() {
      this.getWorkflowDefinition([
        this.workflowDefinitionName,
        this.workflowDefinitionVersion
      ])
    }
  },
  components: {
    JsonEditor
  }
}
</script>
